import { useSyncedCart } from "@ac-expo/hooks";
import {
  Button,
  buttonVariants,
  IconButton,
  RedDot,
} from "@ac-expo/ui-components";
import { useIsSmallDevice } from "@ui/utils";
import { useUserContext } from "@web-app/src/context/auth/user.context";
import environment from "@web-app/src/environments/environment";
import AuthStore from "@web-app/src/services/AuthStore";
import { observer } from "mobx-react-lite";
import Link from "next/link";

type AuthButtonsProps = {
  handleCartClick: () => void;
};

export const AuthButtons = observer(({ handleCartClick }: AuthButtonsProps) => {
  const isSmallDevice = useIsSmallDevice();
  const { isAuthenticated } = useUserContext();
  const { hasItems } = useSyncedCart({ basketType: "store", isAuthenticated });

  return (
    <>
      {!isSmallDevice ? (
        <>
          {/* Styled as a button: the shared Button's `asChild` wraps children in a Fragment. */}
          <Link
            href={environment.BACKOFFICE_URL}
            target="_blank"
            className={buttonVariants({
              variant: "outline-blue",
              className: "mr-4 font-semibold",
            })}
          >
            Se connecter en tant que professionnel
          </Link>
          <Button
            variant="blue"
            color="primary"
            className="font-semibold mr-2"
            onClick={() => AuthStore.setModalVisible(true)}
          >
            Se connecter
          </Button>
          <div className="relative">
            <IconButton
              svgType="cart"
              svgProps={{ size: 24, className: "text-blue-500" }}
              type="button"
              variant="outline-blue"
              aria-label="Mon panier"
              onClick={handleCartClick}
            />
            {hasItems && (
              <RedDot className="absolute -right-0.5 top-0 size-2" />
            )}
          </div>
        </>
      ) : (
        <div className="flex w-full flex-col gap-3">
          <Button
            className="w-full gap-3 relative"
            variant="outline-blue"
            color="primary"
            onClick={handleCartClick}
          >
            {hasItems && <RedDot className="absolute -right-1 -top-1" />}
            <span className="font-semibold">Mon panier</span>
          </Button>
          <Link
            href={environment.BACKOFFICE_URL}
            target="_blank"
            className={buttonVariants({
              variant: "outline-blue",
              className: "w-full font-semibold",
            })}
          >
            Se connecter en tant que pro
          </Link>
          <Button
            variant="blue"
            color="primary"
            onClick={() => AuthStore.setModalVisible(true)}
            className="font-semibold"
          >
            Se connecter
          </Button>
        </div>
      )}
    </>
  );
});
